import type { BuildInfo } from "@/injectionKeys";
import type { Scenario } from "@/composables/forms/formTypes";
import getJsonBlob from "@/utils/getJsonBlob";

export type ExportedScenario = {
  export_info: {
    export_format: number;
    date_created: Date;
    url: Location["href"];
    build_info: BuildInfo;
  };
  payload: Scenario;
};

export default function (
  buildInfo: BuildInfo,
  scenario: Scenario
): {
  snapshot: ExportedScenario;
  filename: string;
  blob: string;
} {
  return {
    snapshot: {
      export_info: {
        export_format: 1,
        date_created: new Date(),
        url: window.location.href,
        build_info: buildInfo
      },
      payload: JSON.parse(JSON.stringify(scenario))
    },
    filename: `${scenario?.title || "export"}.json`,
    blob: getJsonBlob(scenario)
  };
}
